<template>
    <div :title="title">{{postedAt}}</div>
</template>

<script>
export default {
    name: "DateTimeBlock",
    props: [
        'title',
        'dateTime',
    ],
    computed: {
        postedAt() {
            return this._dateTimeFormat(this.dateTime);
        },
    },
}
</script>
